<template>
  <div class="product-grid-panel rounded custom-fade-in mb-0 bg-white w-100 position-relative text-primary">
    <div v-if="product.featured && !isBeingUsedInMarketView" class="featured-overlay">
      <img src="/img/storefront/feature.png" class="featured-icon" />
    </div>
    <div
      v-if="isBeingUsedInMarketView || (product.brand && product.brand.name && product.brand.name != product.company.name)"
      style="position: absolute; z-index: 1; top: 0.5rem; left: 0.5rem"
    >
      <p v-if="isBeingUsedInMarketView" class="product-detail-company mb-0 mx-0 text-white rounded-pill bg-success cursor-pointer">
        {{ product.company.name.length > 33 ? product.company.name.substring(0, 30) + "..." : product.company.name }}
      </p>
      <div v-if="product.brand && product.brand.name && product.brand.name.toLowerCase() != product.company.name.toLowerCase()" class="mt-1">
        <p class="product-detail-company mb-0 mx-0 text-white rounded-pill bg-callout cursor-pointer">
          {{ product.brand.name.length > 33 ? product.brand.name.substring(0, 30) + "..." : product.brand.name }}
        </p>
      </div>
    </div>
    <div ref="productContainer" class="product rounded-top" style="overflow: hidden; width: 100%; position: relative">
      <div
        v-if="product.batches.length == 1 && product.batches[0].back_order"
        :style="`background:var(--success); z-index: 5;`"
        class="preorder text-white d-inline"
      >
        <p class="m-0 text-white">Pre-Order</p>
        <p v-if="product.batches[0].in_stock_expected_date" class="m-0">In stock on: {{ dateShort(product.batches[0].in_stock_expected_date) }}</p>
        <p v-if="!product.batches[0].in_stock_expected_date" class="m-0">Stock Date Unknown</p>
      </div>
      <div ref="imageContainer" class="img-container w-100 position-relative">
        <div
          :class="`product-detail d-flex align-items-center ${
            theme && theme.page_product_layout_rounded_corners_visible.value ? 'rounded' : 'rounded-0'
          } w-100`"
          @click="launchProductDisplayPageModal(product)"
        >
          <div
            style="background: rgba(255, 255, 255, 0.95)"
            :class="`product-detail-inner d-flex flex-column justify-content-center align-items-center font-weight-normal pt-2 ${
              theme && theme.page_product_layout_rounded_corners_visible ? 'rounded-top' : 'rounded-0'
            } h-100 w-100`"
          >
            <ProductGridDetails class="w-90 mt-3" :product="product" @show-pto="launchPTOModal({ product: product, batch: product.batches[0] })" />
            <div style="width: 90%" class="mx-auto mt-auto mb-3 text-center">
              <BushelBtn class="py-2 text-center" outline variant="primary" @click="launchProductDisplayPageModal(product)"> View Product </BushelBtn>
            </div>
          </div>
        </div>
        <div
          :class="`text-center product-image ${
            theme && !theme.page_product_layout_rounded_corners_visible ? 'rounded-0' : 'rounded-top'
          } w-100 h-100`"
        >
          <img :class="`img-fluid w-100`" style="aspect-ratio: 1" :src="determineImageToShow(product)" />
        </div>
      </div>
    </div>
    <div class="cultivar-container d-flex align-items-center">
      <div v-if="productIndustry.length" class="d-flex">
        <span
          v-if="productIndustry == 'Medical' || productIndustry == 'Multiple'"
          style="background: linear-gradient(22deg, #ed5837, #edc637)"
          :style="`${
            product.cultivar_type || productIndustry == 'Multiple' || potencyDisplay ? 'border-radius: 0 0 0 0' : 'border-radius: 0 0.25rem  0 0'
          }`"
          class="dom small px-2 py-1 text-white bg-success"
        >
          Med
        </span>
        <span
          v-if="productIndustry == 'Recreational' || productIndustry == 'Multiple'"
          style="background: linear-gradient(-45deg, #94a3b7, #96a7bc 23%, #9ab4c9 48.77%, #a2c8df 75.76%, #abe1fa)"
          :style="`${product.cultivar_type || potencyDisplay ? 'border-radius: 0 0 0 0' : 'border-radius: 0 0.25rem  0 0'}`"
          class="dom small px-2 py-1 text-white bg-success"
        >
          Rec
        </span>
      </div>
      <div v-if="!product.cultivar_type && !potencyDisplay" class="w-100" style="height: 29px" />
      <div
        v-else
        :style="`position:relative; height: 29px;`"
        :class="`col ${hasAdditionalCannabinoids(product) || hasTerpenes(product) ? ' cultivar-type ' : ''}  ${cultivarType(
          product.cultivar_type,
        )} p-0 `"
      >
        <div :class="` text-nowrap w-100`" style="padding-top: 2px">
          <span v-if="product.cultivar_type" class="text-sm">{{ product.cultivar_type }}</span>
          <span v-if="potencyDisplay" class="text-white text-sm"> <span v-if="product.cultivar_type">-</span> {{ potencyDisplay }} </span>
          <i
            v-if="hasAdditionalCannabinoids(product) || hasTerpenes(product)"
            class="text-white fas fa-ellipsis-v float-right"
            style="margin-top: 3px"
          />
          <div :class="`additional-dropdown px-2 pb-2 my-1 shadow rounded-bottom ${cultivarTypeBgColor(product.cultivar_type)}`">
            <div v-if="hasAdditionalCannabinoids(product)">
              <p class="m-0 font-weight-bold" style="">Additional Cannabinoids:</p>
              <p v-for="(cb, index) in getAdditionalCannabnoids(product).splice(0, 3)" :key="index" class="m-0">
                <span v-if="cb.min != cb.max">{{ cb.name }}: {{ cb.min }}{{ cb.type }} - {{ cb.max }}{{ cb.type }}</span>
                <span v-else>{{ cb.name }}: {{ cb.min }}{{ cb.type }}</span>
              </p>
            </div>
            <hr v-if="hasTerpenes(product)" style="margin: 0.25rem 0" />
            <div v-if="hasTerpenes(product)">
              <p class="m-0 font-weight-bold" style="">Terpenes:</p>
              <p v-for="(cb, index) in getTerpenes(product).splice(0, 3)" :key="index + 1" class="m-0">
                <span v-if="cb.min != cb.max">{{ cb.name }}: {{ cb.min }}{{ cb.type }} - {{ cb.max }}{{ cb.type }}</span>
                <span v-else>{{ cb.name }}: {{ cb.min }}{{ cb.type }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-container px-2 pb-0">
      <div>
        <div class="row m-0" style="margin-top: -20px !important">
          <div class="col-12 pl-0">
            <h1 class="m-0 text-dark" style="font-weight: 600; font-size: 14px">
              {{ productTitleCharLimit(product.product_name, 65) }}
            </h1>
          </div>
          <div class="col-12 pl-0 product-detail-title">
            <p style="font-size: 12px" class="p-0 m-0 text-one-line-with-ellipsis">
              {{ `${product.category_name}${product.category_name == "Edibles & Drink" ? "s" : ""}` }}
              <span v-if="product.product_type"> - {{ product.product_type }}</span>
            </p>
          </div>
        </div>
        <div v-if="!hidePrices">
          <div v-if="product.category_name != 'Pack To Order'" class="row m-0 align-items-end">
            <div class="col pl-0">
              <div v-if="isDiscountedProduct(product)" class="d-inline pt-1">
                <p
                  style="text-decoration: line-through; font-size: 12px; line-height: 12px"
                  class="text-success m-0 line-through m-0 d-block mt-1 text-danger"
                >
                  {{ getProductMinMaxPrice(product) }}
                </p>
                <p style="font-weight: 600; font-size: 14px; line-height: 14px" class="p-0 m-0 d-inline text-dark">
                  {{ getProductTierMinMaxPrice(product) }}
                </p>
              </div>
              <p v-else style="font-weight: 600; font-size: 14px" class="p-0 m-0 d-inline text-dark">
                {{ getProductMinMaxPrice(product) }}
              </p>
              <p class="mb-0 small d-inline">
                /
                <span>{{ getUnit(product).name }}</span>
                <span v-if="product.packaged_unit_size" class="m-0"> - {{ product.packaged_unit_size }} </span>
              </p>
              <div v-if="isTheSeller && product.batches && product.batches.length == 1 && product.batches[0].minimum_sales_price" class="text-sm">
                <span class="text-danger text-sm"
                  ><b> Min Price ${{ product.batches[0].minimum_sales_price / 100 }} </b></span
                >
              </div>
            </div>
          </div>
          <div v-else class="d-flex align-items-center px-0">
            <p style="font-weight: 600; font-size: 14px" class="m-0">
              ${{
                countDecimals(ptoGetMinPrice(product.batches[0]) / 100) > 0
                  ? (ptoGetMinPrice(product.batches[0]) / 100).toFixed(2)
                  : ptoGetMinPrice(product.batches[0]) / 100
              }}
            </p>
            <p style="font-weight: 600" class="m-0 ml-1">-</p>
            <p style="font-weight: 600; font-size: 14px" class="m-0 ml-1">
              ${{
                countDecimals(ptoGetMaxPrice(product.batches[0]) / 100) > 0
                  ? (ptoGetMaxPrice(product.batches[0]) / 100).toFixed(2)
                  : ptoGetMaxPrice(product.batches[0]) / 100
              }}
            </p>
          </div>
        </div>

        <div v-if="!hideQuantity || !hidePrices">
          <div v-if="!hideQuantity" class="row m-0 mb-0">
            <div class="col pl-0">
              <p class="small text-dark mb-0 nowrap">
                <span class="font-weight-bold">Quantity:</span>
                <!-- <span v-if="product.disable_inventory_tracking">Unlimited</span> -->
                <span class="ml-1">{{ calculateStorefrontListingQuantity(product) }}</span>
                <span class="ml-1">{{ getUnit(product).name }}</span>
                <InfoTooltipBase
                  v-if="product.units_per_package || product.units_per_case"
                  :id="`${product.id}-package-case-tooltip`"
                  class="ml-1"
                  :text="getFullUnitBreakdown(product)"
                />
              </p>
              <p v-if="quantityInCart(product, true)" class="small m-0 ml-1">
                (<span>
                  <span v-if="sampleInCart(product)"> <i class="fa fa-gift" /> | </span>

                  {{ quantityInCart(product) }}
                </span>
                in <i class="fa fa-shopping-cart" />)
              </p>
              <p v-else-if="sampleInCart(product)" class="small mb-0 ml-2">(<i class="fa fa-gift" /> in <i class="fa fa-shopping-cart" />)</p>
            </div>
          </div>
          <div v-if="!hidePrices && Object.keys(unitMeasurementPriceBreakdown).length" class="px-0 mt-1" style="height: 16px; line-height: 13px">
            <span v-for="value in unitMeasurementPriceBreakdown" :key="value" class="badge border mr-1 text-small"> {{ value }}</span>
          </div>
        </div>
      </div>
      <div v-if="!hideShoppingActions" style="width: 100%" class="mt-2">
        <div class="px-0 w-100" style="margin-bottom: 0.5rem; bottom: 0">
          <div v-if="product.batches.length > 1">
            <div class="row">
              <!-- <StoreFrontChat
                v-if="showChat"
                :authorized="user ? true : false"
                :user="user"
                :from-company-id="user.current_company_id"
                :to-company-id="product.company_id"
                :to-company-uuid="product.company.uuid"
                :to-company-name="product && product.company && product.company.name ? product.company.name : null"
                class="d-inline-block rounded col-2"
                icon-style="font-size: 16px;"
                btn-class="btn-sm"
                btn-style="height: 37px; width: 90%;"
              /> -->
              <div class="col-12">
                <BushelBtn
                  class="btn-block w-100 pl-0 pr-0 mr-0"
                  style="height: 38px"
                  :class="disableStorefrontTheme ? '' : 'templateButton'"
                  :variant="disableStorefrontTheme ? 'success' : ''"
                  :disabled="buyer && buyer.hold"
                  @click="openMultipleBatchModal(product)"
                >
                  <i class="fas fa-bars" />
                </BushelBtn>
              </div>
            </div>
          </div>
          <!-- This shouldn't be shown, but just in case it is -->
          <div v-else-if="product.batches[0].hold" class="border form-control">
            <p class="mb-0">
              On Deck <i :id="`holdinputsection${product.batches[0].id}`" class="fas fa-question text-info cursor-default" />

              <BTooltip :target="`holdinputsection${product.batches[0].id}`" triggers="hover" placement="left">
                This Batch is On Deck and can be ordered once available batches have sold out.
              </BTooltip>
            </p>
          </div>

          <div v-else-if="product.category_name !== 'Pack To Order'" class="row m-0 align-items-center">
            <!-- <StoreFrontChat
              v-if="showChat"
              :authorized="user ? true : false"
              :user="user"
              :from-company-id="user.current_company_id"
              :to-company-id="product.company_id"
              :to-company-uuid="product.company.uuid"
              :to-company-name="product && product.company && product.company.name ? product.company.name : null"
              class="d-inline-block rounded"
              icon-style="font-size: 16px;"
              btn-class="btn-sm"
              btn-style="height: 37px;"
            /> -->

            <BushelTextInput
              :value="quantity"
              class="col p-0 m-0"
              type="number"
              label-class="d-none"
              placeholder="Quantity"
              :disabled="buyer && buyer.hold"
              no-bottom-padding
              :error="!product.disable_inventory_tracking && product.quantity < Number(quantity) + quantityInCart(product, true)"
              :number-type-allow-decimal="categoryTypeCanHaveDecimal(product.category_name, product)"
              :number-type-max-precision="6"
              @enter="addCartItem(product)"
              @input="(value) => (quantity = value)"
            />
            <BushelBtn
              class="ml-2 rounded"
              :style="`width: 40px; height: 38px; --btnColor: ${btnColor}; --btnBgColor: ${btnBackgroundColor}`"
              :disabled="addToCartBtnDisabled(product)"
              :class="disableStorefrontTheme ? '' : ''"
              :variant="disableStorefrontTheme ? 'success' : 'custom'"
              @click="addCartItem(product)"
            >
              <i class="fa fas fa-plus" />
            </BushelBtn>

            <BushelBtn
              v-if="product.batches.length == 1 && product.batches[0].samples_available && !sampleInCart(product) && !product.batches[0].hold"
              :ripple="false"
              style="width: 40px; height: 38px"
              class="btn-block m-0 ml-2 px-0 rounded"
              :disabled="buyer && buyer.hold"
              :class="disableStorefrontTheme ? '' : 'templateButton'"
              :variant="disableStorefrontTheme ? 'success' : ''"
              @click="addSample(product)"
            >
              <i class="fas fa-gift" />
            </BushelBtn>
          </div>

          <div v-else-if="product.category_name == 'Pack To Order'" class="d-flex mb-0">
            <StoreFrontChat
              v-if="showChat"
              :authorized="user ? true : false"
              :user="user"
              :from-company-id="user.current_company_id"
              :to-company-id="product.company_id"
              :to-company-uuid="product.company.uuid"
              :to-company-name="product && product.company && product.company.name ? product.company.name : null"
              class="d-inline-block rounded"
              icon-style="font-size: 16px;"
              btn-class="btn-sm"
              btn-style="height: 37px;"
            />

            <BushelBtn
              class="btn-block"
              :class="disableStorefrontTheme ? '' : 'templateButton'"
              :variant="disableStorefrontTheme ? 'success' : ''"
              :disabled="buyer && buyer.hold"
              style="height: 38px"
              @click="launchPTOModal({ product: product, batch: product.batches[0] })"
            >
              <i class="fas fa-calculator" />
            </BushelBtn>

            <BushelBtn
              v-if="product.samples_available && !sampleInCart(product)"
              :ripple="false"
              class="btn-block m-0 ml-2 px-0"
              :disabled="buyer && buyer.hold"
              :class="disableStorefrontTheme ? '' : 'templateButton'"
              :variant="disableStorefrontTheme ? 'success' : ''"
              style="height: 38px"
              @click="addSample(product)"
            >
              <i class="fas fa-gift" />
            </BushelBtn>
          </div>
        </div>
      </div>
    </div>
    <ProductDisplayPageModal
      v-if="selectedProduct"
      :key="productDisplayPageModalKey"
      :company="company"
      :buyer-id="buyer ? buyer.id : null"
      :show="showProductModal !== false"
      :on-marketplace="isBeingUsedInMarketView"
      :selected-product="selectedProduct"
      :bulk-discounts="productCurrentlyShowingBulkDiscounts"
      :selected-batch-id="selectedBatchId"
      :hide-prices="hidePrices"
      :user="user"
      :hide-quantities="hideQuantity"
      :disable-add="hideShoppingActions"
      :use-cannabis-spinner="useCannabisSpinner"
      :cart-items="cartItems"
      :cart-needs-to-be-chosen="cartNeedsToBeChosen"
      :active-location="activeLocation"
      @hide="hideProductDisplayPageModal"
      @added-product="addProductFromDisplayPage"
      @contact-button-clicked="pdpContactClicked"
      @launch-p-t-o-modal="handleLaunchingPTOModalFromPDPModal"
    />

    <PTOModal
      :key="ptoModalKey"
      :show="isShowingPTOModal"
      :product="ptoProduct"
      :batch="ptoBatch"
      :existing-quantity="ptoCurrentQuantity ? ptoCurrentQuantity : 0"
      @hide="isShowingPTOModal = false"
      @create-pack-to-order-items="createPackToOrderItems"
    />
    <MultipleBatchModal
      :key="multiBatchModalKey"
      :is-the-seller="isTheSeller"
      :show="isShowingMultiBatchModal"
      :product="multiBatchModalProduct"
      :cart-items="cartItems && cartItems.length > 0 ? cartItems : []"
      @hide="isShowingMultiBatchModal = false"
      @added-product="createMultiBatchItems"
      @launch-p-t-o-modal="handleLaunchingPTOModalFromMultiBatchModal"
      @launch-product-display-page="launchProductDisplayPageModal(multiBatchModalProduct)"
    />
  </div>
</template>
<script>
import {
  getUnit,
  getUnitSize,
  cultivarType,
  cultivarTypeBgColor,
  ptoGetMinPrice,
  ptoGetMaxPrice,
  calculateStorefrontPotencyDisplay,
  calculateStorefrontListingQuantity,
  getFullUnitBreakdown,
  getUnitMeasurementPriceBreakdown,
  getProductMinMaxPrice,
  isDiscountedProduct,
  getProductTierMinMaxPrice,
} from "@/services/storefront/storefront";
import { dateShort } from "@/services/filters";
import { categoryTypeCanHaveDecimal } from "@/services/inventory/inventory";
import ProductGridDetails from "./ProductGridDetails.vue";
import MultipleBatchModal from "@/components/storefront/multipleBatch/MultipleBatchModal.vue";
import ProductDisplayPageModal from "@/components/productDisplay/ProductDisplayPageModal.vue";
import PTOModal from "@/components/storefront/PTOModal.vue";
import InfoTooltipBase from "@/components/common/InfoTooltipBase.vue";
import StoreFrontChat from "@/components/storefront/StoreFrontChat.vue";

export default {
  name: "ProductGridPanel",
  components: {
    ProductGridDetails,
    MultipleBatchModal,
    ProductDisplayPageModal,
    PTOModal,
    InfoTooltipBase,
    StoreFrontChat,
  },
  props: {
    product: { type: Object },
    theme: { type: Object },
    company: { type: Object },
    user: { type: Object, default: null },
    buyer: { type: Object, default: null },
    cartItems: { type: Array },
    disableStorefrontTheme: { type: Boolean, default: false },
    cartNeedsToBeChosen: { type: Boolean, default: false },
    isBeingUsedInMarketView: { type: Boolean, default: false },
    hideShoppingActions: { type: Boolean, default: false },
    hidePrices: { type: Boolean, default: false },
    useCannabisSpinner: { type: Boolean, default: true },
    hideQuantity: { type: Boolean, default: false },
    isTheSeller: { type: Boolean, required: true },
    bulkDiscounts: { type: Array, required: true },
    chatEnabled: { type: Boolean, default: false },
    activeLocation: { type: Object },
  },
  emits: ["contactButtonClicked", "add-to-cart"],
  data() {
    return {
      quantity: "",
      multiBatchModalProduct: {},
      multiBatchModalKey: 42342,
      isShowingMultiBatchModal: false,
      selectedBatchId: null,
      selectedProduct: null,
      showProductModal: false,
      isShowingPTOModal: false,
      ptoModalKey: 52535,
      ptoCurrentQuantity: 0,
      productDisplayPageModalKey: 35353,
      productCurrentlyShowingBulkDiscounts: [],
      ptoProduct: {},
      ptoBatch: {},
      unitMeasurementPriceBreakdown: {},
    };
  },
  computed: {
    potencyDisplay() {
      return this.calculateStorefrontPotencyDisplay(this.product);
    },
    productIndustry() {
      const { product } = this;
      let industry = "";
      let multipleIndustries = false;
      for (let i = 0; i < product.batches.length; i += 1) {
        if (
          product.batches[i].operation &&
          product.batches[i].operation.state &&
          product.batches[i].operation.state.display_med_rec_designations &&
          product.batches[i].operation.industry
        ) {
          if (industry == "" || product.batches[i].operation.industry == industry) {
            industry = product.batches[i].operation.industry;
          } else {
            multipleIndustries = true;
            break;
          }
        }
      }
      if (multipleIndustries) {
        industry = "Multiple";
      }
      return industry;
    },
    cssVars() {
      return {
        borderColor:
          this.theme && this.theme.page_product_layout_border_color
            ? `${this.theme.page_product_layout_border_color} !important`
            : "rgba(0,0,0,0.1) !important",
        // 'border-radius': this.theme && !this.theme.page_product_layout_rounded_corners_visible.value ? '0 !important' : '',
        borderRadius: this.theme && this.theme.page_product_layout_rounded_corners_visible && !this.disableStorefrontTheme ? "0.85rem" : "0px",
        boxShadow: this.theme && this.theme.page_product_layout_box_shadow_visible ? "0 0.5rem 1rem rgba(0, 0, 0, 0.05)" : null,
      };
    },
    btnBackgroundColor() {
      return this.theme && this.theme.page_button_color ? this.theme.page_button_color : "#000";
    },
    btnColor() {
      return this.theme && this.theme.page_button_text_color ? this.theme.page_button_text_color : "#ffffff";
    },
    showChat() {
      if (
        this.chatEnabled &&
        this.user
        // && (this.company.id != this.user.current_company_id)
      ) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    if (!this.hidePrices && this.product.batches && this.product.batches.length == 1) {
      this.unitMeasurementPriceBreakdown = this.getUnitMeasurementPriceBreakdown(this.product, this.product.batches[0]);
    }
  },

  methods: {
    getUnitSize,
    getUnitMeasurementPriceBreakdown,
    getUnit,
    categoryTypeCanHaveDecimal,
    cultivarType,
    cultivarTypeBgColor,
    ptoGetMinPrice,
    ptoGetMaxPrice,
    calculateStorefrontPotencyDisplay,
    calculateStorefrontListingQuantity,
    getFullUnitBreakdown,
    getProductMinMaxPrice,
    isDiscountedProduct,
    getProductTierMinMaxPrice,
    dateShort,
    addToCartBtnDisabled(product) {
      if (!this.quantity) {
        return true;
      }

      if (!product.disable_inventory_tracking && product.quantity < Number(this.quantity) + this.quantityInCart(product, true)) {
        return true;
      }

      if (this.buyer && this.buyer.hold) {
        return true;
      }
      return false;
    },
    hasAdditionalCannabinoids(product) {
      let found = false;
      if (product.batches) {
        product.batches.forEach((batch) => {
          if (batch.additional_cannabinoids.length > 0) {
            found = true;
          }
        });
      }
      return found;
    },
    hasTerpenes(product) {
      let found = false;
      if (product.batches) {
        product.batches.forEach((batch) => {
          if (batch.terpenes.length > 0) {
            found = true;
          }
        });
      }
      return found;
    },
    getAdditionalCannabnoids(product) {
      const additionals = [];
      if (product.batches) {
        product.batches.forEach((batch) => {
          if (batch.additional_cannabinoids.length > 0) {
            batch.additional_cannabinoids.forEach((cannabinoid) => {
              if (
                !additionals.some(
                  (additional) => additional.name == cannabinoid.abbreviation && additional.type == cannabinoid.pivot?.measurement_type,
                )
              ) {
                additionals.push({
                  name: cannabinoid.abbreviation,
                  min: cannabinoid.pivot?.measurement,
                  max: cannabinoid.pivot?.measurement,
                  type: cannabinoid.pivot?.measurement_type,
                });
              } else {
                const index = additionals.findIndex(
                  (additional) => additional.name == cannabinoid.abbreviation && additional.type == cannabinoid.pivot?.measurement_type,
                );
                if (cannabinoid.pivot?.measurement < additionals[index].min) {
                  additionals[index].min = cannabinoid.pivot?.measurement;
                }
                if (cannabinoid.pivot?.measurement > additionals[index].max) {
                  additionals[index].max = cannabinoid.pivot?.measurement;
                }
              }
            });
          }
        });
      }
      return additionals.sort((a, b) => {
        if (a.min < b.min && a.max <= b.max) {
          return 1;
        }
        if (a.min <= b.min && a.max < b.max) {
          return 1;
        }
        if (a.min > b.min && a.max >= b.max) {
          return -1;
        }
        if (a.min >= b.min && a.max > b.max) {
          return -1;
        }

        return 0;
      });
    },
    getTerpenes(product) {
      const additionals = [];
      if (product.batches) {
        product.batches.forEach((batch) => {
          if (batch.terpenes.length > 0) {
            batch.terpenes.forEach((terp) => {
              if (!additionals.some((additional) => additional.name == terp.displayName && additional.type == terp.pivot?.measurement_type)) {
                additionals.push({
                  name: terp.displayName,
                  min: terp.pivot?.measurement,
                  max: terp.pivot?.measurement,
                  type: terp.pivot?.measurement_type,
                });
              } else {
                const index = additionals.findIndex(
                  (additional) => additional.name == terp.displayName && additional.type == terp.pivot?.measurement_type,
                );
                if (terp.pivot?.measurement < additionals[index].min) {
                  additionals[index].min = terp.pivot?.measurement;
                }
                if (terp.pivot?.measurement > additionals[index].max) {
                  additionals[index].max = terp.pivot?.measurement;
                }
              }
            });
          }
        });
      }
      return additionals.sort((a, b) => {
        if (a.min < b.min && a.max <= b.max) {
          return 1;
        }
        if (a.min <= b.min && a.max < b.max) {
          return 1;
        }
        if (a.min > b.min && a.max >= b.max) {
          return -1;
        }
        if (a.min >= b.min && a.max > b.max) {
          return -1;
        }

        return 0;
      });
    },
    productTitleCharLimit(title, length) {
      if (title.length > length) {
        return `${title.substring(0, length)}...`;
      }
      return title;
    },
    countDecimals(value) {
      if (value % 1 != 0) {
        return value.toString().split(".")[1].length;
      }
      return 0;
    },
    addSample(product) {
      const batchId = product.batches[0].id;
      const item = {
        company_id: product.company_id,
        product_id: product.id,
        batch_id: batchId,
        quantity: 1,
        sample: true,
      };
      const data = { cartItems: [item] };
      this.$emit("add-to-cart", data);
    },
    addCartItem(product) {
      const batchId = product.batches[0].id;

      const item = {
        company_id: product.company_id,
        batch_id: batchId,
        product_id: product.id,
        quantity: this.quantity,
        sample: false,
      };
      const data = { cartItems: [item] };
      this.quantity = null;
      this.$emit("add-to-cart", data);
    },
    createMultiBatchItems(multiBatchData) {
      // this.multiBatchModalKey += 1;
      const data = { cartItems: [multiBatchData] };
      this.$emit("add-to-cart", data);
    },
    openMultipleBatchModal(product) {
      this.multiBatchModalProduct = { ...product };
      this.multiBatchModalKey += 1;
      this.isShowingMultiBatchModal = true;
    },
    hideProductDisplayPageModal() {
      this.productCurrentlyShowingBulkDiscounts = [];
      this.showProductModal = false;
      this.selectedBatchId = null;
    },
    pdpContactClicked() {
      this.hideProductDisplayPageModal();
      this.$emit("contactButtonClicked");
    },
    launchProductDisplayPageModal(selectedProduct) {
      const product = selectedProduct;
      this.productDisplayPageModalKey += 1;
      this.selectedProduct = product;
      if (product.batches && product.batches.length == 1) {
        this.selectedBatchId = product.batches[0].id;
      }
      this.productCurrentlyShowingBulkDiscounts = this.bulkDiscounts.filter((discount) => {
        if (product.product_type_id) {
          return discount.product_type_id == product.type_id;
        }
        return discount.product_category_id == product.category_id;
      });
      this.showProductModal = true;
      // this.productCurrentlyShowingBulkDiscounts = ['one', 'two', 'test'];
    },
    addProductFromDisplayPage(data) {
      const item = {
        batch_id: data.batch_id,
        quantity: data.quantity,
        sample: data.sample,
        product_id: data.product_id,
      };
      const payload = { cartItems: [item] };
      this.$emit("add-to-cart", payload);
    },
    launchPTOModal(data) {
      this.ptoProduct = { ...data.product };
      this.ptoBatch = { ...data.batch };
      this.ptoCurrentQuantity = this.quantityInCart(data.product, true);
      this.ptoModalKey += 1;
      this.isShowingPTOModal = true;
    },
    createPackToOrderItems(ptoObject) {
      this.ptoModalKey += 1;
      const data = { cartItems: [ptoObject] };
      this.$emit("add-to-cart", data);
    },
    handleLaunchingPTOModalFromPDPModal(val) {
      this.hideProductDisplayPageModal();
      this.launchPTOModal({ product: val.product, batch: val.batch });
    },
    determineImageToShow(product) {
      if (product.images && product.images.length > 0) {
        return product.images[0].imageLink;
      }
      if (product.brand && product.brand.logoLink && !product.brand.logoLink.includes("gravatar") && !product.brand.logoLink.includes("no-image")) {
        return product.brand.logoLink;
      }
      if (this.isBeingUsedInMarketView && product.company.logoLink && !product.company.logoLink.includes("gravatar")) {
        return product.company.logoLink;
      }

      return "/img/misc/no-image-square.png";
    },

    quantityInCart(tableItem, returnValue = false) {
      let returnData = 0;
      if (this.cartItems && this.cartItems.length) {
        // if(tableItem.category_name === 'Pack To Order') {
        const foundItems = this.cartItems.filter((item) => {
          // (item.batch_id == tableItem.id) && (item.product_id == tableItem.product_id) && !item.sample,
          if (tableItem.batches.length == 1) {
            if (item.batch_id == tableItem.batches[0].id && item.product_id == tableItem.id && !item.sample) {
              return true;
            }
            return false;
          }

          if (item.product_id == tableItem.id && !item.sample) {
            return true;
          }
          return false;
        });

        for (let i = 0; i < foundItems.length; i += 1) {
          returnData += foundItems[i].quantity;
        }

        if (returnValue) {
          return Number(returnData);
        }

        return `${returnData.toString()}`;

        // const foundItem = this.cartItems.find(
        //   (item) => { // (item.batch_id == tableItem.id) && (item.product_id == tableItem.product_id) && !item.sample,
        //     if (tableItem.batches.length == 1) {
        //       if ((item.batch_id == tableItem.batches[0].id) && (item.product_id == tableItem.id) && !item.sample) {
        //         return true;
        //       }
        //       return false;
        //     }
        //
        //     if ((item.product_id == tableItem.id) && !item.sample) {
        //       return true;
        //     }
        //     return false;
        //   },
        // );

        // if (returnValue) {
        //   if (foundItem) {
        //     return Number(foundItem.quantity);
        //   }
        //   return 0;
        // }
        // else if (foundItem) {
        //   return `${foundItem.quantity.toString()}`;
        // }
      }

      return "";
    },
    handleLaunchingPTOModalFromMultiBatchModal(val) {
      this.isShowingMultiBatchModal = false;
      this.launchPTOModal({ product: val.product, batch: val.batch });
    },
    sampleInCart(tableItem) {
      if (this.cartItems && this.cartItems.length) {
        const foundItem = this.cartItems.find((item) => {
          if (tableItem.batches.length == 1) {
            if (item.batch_id == tableItem.batches[0].id && item.product_id == tableItem.id && item.sample) {
              return true;
            }
            return false;
          }

          if (item.product_id == tableItem.id && item.sample) {
            return true;
          }
          return false;
        });

        if (foundItem) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@sass/_mixins.scss";

.product-detail-company {
  font-size: 12px;
  font-weight: 300;
  padding: 1px 6px;
  width: max-content;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.transition-height {
  transition: height 1s;
}

.product-grid-panel {
  transition: all 1s;
  min-width: 250px !important;
  border-radius: 0.75rem;
  display: flex;
  flex-direction: column;
}

// .product-grid-panel-flex-optional-css {
//   @include flex-wrap-fix(350px);
//   max-width: 350px;
//   margin-left: .5rem;
//   margin-right: .5rem;
//   margin-top: .5rem;
//   margin-bottom: .5rem;
//   flex-grow: 1;
//   flex-shrink: 1;
//   flex-basis: 250px;
//   // min-width:250px !important;
//   border-radius: 0.75rem;
//   transition: all 1s
// }

// .product-detail-title {
//   display: flex;
//   align-items: center;
//   // max-height: 3rem;
//   // min-height: 3rem;
//
//   h1 {
//     display: -webkit-box;
//     -webkit-line-clamp: 1;
//     -webkit-box-orient: vertical;
//
//     overflow : hidden;
//     text-overflow: ellipsis;
//     font-weight: 600;
//     font-size: 16px;
//   }
// }
// .image-box {
//
//   //height:300px !important;
//   //height:var(--height) !important;
//   width:100%;
//   background-size:cover !important;
//   background-position:center !important;
//
// }
.img-container:hover .product-detail {
  display: block !important;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  // bottom: 27px;
  border-radius: 1rem 1rem 0 0;
  // height: 303px;
  // height: calc(100% - 196px);
}

.img-container:hover .product-detail-inner {
  animation: fadeIn ease 0.5s;
  -webkit-animation: fadeIn ease 0.5s;
  -moz-animation: fadeIn ease 0.5s;
  -o-animation: fadeIn ease 0.5s;
  -ms-animation: fadeIn ease 0.5s;
  position: relative;
  z-index: 9;
}

.product-detail {
  height: var(--image-height) !important;
}

.img-container .product-detail {
  display: none !important;
}

.product-detail table td {
  color: var(--primary) !important;
}

.templateButton {
  background-color: v-bind(btnBackgroundColor) !important;
  color: v-bind(btnColor) !important;
}

.templateButtonBorder {
  border: 1px solid var(--bg-color) !important;
}

.cultivar-container {
  position: relative;
  top: -29px;
  z-index: 2;
  min-height: 27px;
  width: 100%;
}

.cultivar-container:hover {
  cursor: default;
}

.cultivar-container .additional-dropdown {
  display: none;
}

.cultivar-container .cultivar-type:hover .additional-dropdown {
  width: 100%;
  z-index: 1050;
  position: absolute;
  display: block;
  left: 0;
  padding: 0.25rem;
  margin-top: 3px;
  border-radius: 0 0 0.75rem 0.75rem;
}

.content-container {
  display: grid;
  grid-template-rows: 1fr auto;
  min-height: 0;
  flex: 1;
}

.preorder {
  position: absolute;
  z-index: 2;
  left: -67px;
  padding: 3px;
  width: 250px;
  top: 24px;
  font-size: 12px;
  text-align: center;
  transform: rotate(-40deg);
}

.vertical-container {
  display: table;
  float: left;
  overflow: hidden;
  width: 100%;
  z-index: -100;
}

.vertical-container span {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

.featured-overlay {
  position: absolute;
  height: 1rem;
  width: 1rem;
  z-index: 1;
  webkit-transform: scaleX(-1);
  transform: scaleX(-1);
  right: 0;
  top: 1px;
}
.featured-icon {
  margin-top: -1px;
  width: 75px;
  height: 75px;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

* {
  --btnBgColor: #000;
  --btnColor: #fff;
}

.btn-custom {
  background-color: var(--btnBgColor) !important;
  color: var(--btnColor) !important;
}

.btn-custom:hover {
  opacity: 0.9;
}

.btn-custom:disabled {
  opacity: 0.5;
}
</style>
